import { EntityState, Store } from "@datorama/akita";

export abstract class NrtStore<
  TState extends EntityState
> extends Store<TState> {

}
